import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashOmit from 'lodash/fp/omit';

import {
  SR_API_ACTION_CLONE_BREED_RESTRICTIONS,
  SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA,
} from 'api/actionTypes';

import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';
import getTenantScreeningCriteriaAction from 'client/actions/TenantScreeningCriteria/getTenantScreeningCriteria';

import SrTenantScreeningCriteriaModal from 'client/components/SrTenantScreeningCriteriaModal';

@branch((props) => {
  const mappings = {};
  if (props.listing) {
    mappings.listingTenantScreeningCriteria = ['tenantScreeningCriteria', 'byListingId', props.listing.id];
    if (props.listing.listingManagementCompany) {
      mappings.partnerTenantScreeningCriteria = ['tenantScreeningCriteria', 'byPartnerManagementCompany', props.listing.listingManagementCompany]; // eslint-disable-line max-len
    }
  }
  else if (props.partner) {
    mappings.partnerTenantScreeningCriteria = ['tenantScreeningCriteria', 'byPartnerManagementCompany', props.partner.managementCompanyName]; // eslint-disable-line max-len
  }
  return mappings;
})
@withApiState({
  loadListingTenantScreeningCriteriaApiState: {
    action: SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA,
    queryId: 'byListing',
  },
  loadPartnerTenantScreeningCriteriaApiState: {
    action: SR_API_ACTION_GET_TENANT_SCREENING_CRITERIA,
    queryId: 'byPartner',
  },
})
class SrEditListingTenantScreeningCriteriaCta extends Component {
  static propTypes = {
    listing: PropTypes.object,
    partner: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    listingTenantScreeningCriteria: PropTypes.object,
    partnerTenantScreeningCriteria: PropTypes.object,
    loadListingTenantScreeningCriteriaApiState: PropTypes.object.isRequired,
    loadPartnerTenantScreeningCriteriaApiState: PropTypes.object.isRequired,
    omitApiActions: PropTypes.bool,
    onSubmit: PropTypes.func,
    children: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      tenantScreeningCriteriaModalIsOpen: false,
    };
  }

  componentDidMount() {
    this._loadListingTenantScreeningCriteria(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listing?.id !== this.props.listing?.id) {
      this._loadListingTenantScreeningCriteria(this.props);
    }
  }

  _loadListingTenantScreeningCriteria = ({ listing, partner }) => {
    const { dispatch } = this.props;
    if (listing) {
      dispatch(getTenantScreeningCriteriaAction, {
        queryId: 'byListing',
        listingId: listing.id,
        reload: true,
      });
    }
    if (partner || listing?.listingManagementCompany) {
      dispatch(getTenantScreeningCriteriaAction, {
        queryId: 'byPartner',
        managementCompanyName: partner?.managementCompanyName || listing?.listingManagementCompany,
        reload: true,
      });
    }
  }

  _onTenantScreeningCriteriaModalSubmit = (tenantScreeningCriteria) => {
    const {
      listing,
      onSubmit,
      dispatch,
    } = this.props;

    if (listing) {
      dispatch(getTenantScreeningCriteriaAction, {
        queryId: 'byListing',
        listingId: listing.id,
        reload: true,
      });
    }
    if (onSubmit) {
      onSubmit(tenantScreeningCriteria);
    }
    this._onTenantScreeningCriteriaModalClose();
  }

  _onTenantScreeningCriteriaModalClose = () => {
    this.setState({
      tenantScreeningCriteriaModalIsOpen: false,
    });
  }

  _onTenantScreeningCriteriaModalOpen = () => {
    this.setState({
      tenantScreeningCriteriaModalIsOpen: true,
    });
  }

  _onCopyPartnerRestrictedBreeds = () => {
    const { listing, partner, dispatch } = this.props;
    if (!global.confirm(
      'Are you sure you want to copy the breed restrictions from the ' +
      'partner settings into this listing?'
    )) {
      return;
    }
    dispatch(postWithState, {
      action: SR_API_ACTION_CLONE_BREED_RESTRICTIONS,
      payload: {
        fromPartnerId: partner.id,
        listingId: listing.id,
      },
    })
      .then(() => {
        return dispatch(getTenantScreeningCriteriaAction, {
          queryId: 'byListing',
          listingId: listing.id,
          reload: true,
        });
      })
      .then(() => {
        this._onTenantScreeningCriteriaModalClose();
        global.alert('The partner breed restrictions have been copied to this listing.');
      });
  }

  render() {
    const {
      listing,
      partner,
      listingTenantScreeningCriteria,
      partnerTenantScreeningCriteria,
      loadListingTenantScreeningCriteriaApiState,
      loadPartnerTenantScreeningCriteriaApiState,
      omitApiActions,
      children,
      dispatch,
    } = this.props;

    const {
      tenantScreeningCriteriaModalIsOpen,
    } = this.state;

    if (
      loadListingTenantScreeningCriteriaApiState.inProgress
      || loadPartnerTenantScreeningCriteriaApiState.inProgress
    ) {
      return null;
    }

    return (
      <div className='SrEditListingTenantScreeningCriteriaCta'>
        <span onClick={this._onTenantScreeningCriteriaModalOpen}>
          {children}
        </span>
        {tenantScreeningCriteriaModalIsOpen && (
          <SrTenantScreeningCriteriaModal
            {...tenantScreeningCriteriaModalIsOpen}
            defaultValues={{
              listingId: listing?.id,
              ...(listingTenantScreeningCriteria
                || (partnerTenantScreeningCriteria
                  ? lodashOmit(['id'], partnerTenantScreeningCriteria)
                  : {}
                )
              ),
            }}
            onSubmit={this._onTenantScreeningCriteriaModalSubmit}
            onClose={this._onTenantScreeningCriteriaModalClose}
            onCopyPartnerRestrictedBreeds={listing && partner ? this._onCopyPartnerRestrictedBreeds : null}
            dispatch={dispatch}
            omitApiActions={omitApiActions}
          />
        )}
      </div>
    );
  }
}

SrEditListingTenantScreeningCriteriaCta.displayName = 'SrEditListingTenantScreeningCriteriaCta';

export default SrEditListingTenantScreeningCriteriaCta;
